import { useQuery } from "@tanstack/react-query";

import { onboardingProcessStepsQuery } from "#modules/onboardingV2/infra/onboardingProcessSteps.query";

export const useOnboardingProcessSteps = () => {
  const { data, ...rest } = useQuery(onboardingProcessStepsQuery());

  return { processSteps: data ?? [], ...rest };
};
